import React, { useCallback } from 'react';
import { Panel, PanelType, mergeStyles } from '@fluentui/react';
import { BwjButton, IBwjButtonProps } from '../bwj-button';
import { BwjScrollContainer } from '../bwj-scroll-container';
import { BwjSemiFlexContainer } from '../bwj-semi-flex-container';
import { isTouchDevice } from '../../utils/device';


interface IBwjSidePanelProps {
    showPanel: boolean;
    title?: string;
    panelType?: PanelType;
    footerButtons?: IBwjButtonProps[];
    onDismiss: () => void;
    closeButtonAriaLabel?: string;
    isLightDismiss?: boolean;
}

const panelStyles = {
  main: {
    '@media (min-width: 480px)': {
      width: 480,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
    width: '100%',
  }
};

const scrollablePanelClass = mergeStyles([
  {
    '& div[class*="scrollableContent"]': {
      display: 'flex',
      flexGrow: 1,
    }
  },
]);

const scrollButtonPaddingClass = mergeStyles({
  width: '100%',
  height: 0,
  marginBottom: 96,
});

const footerButtonTrayClass = mergeStyles([
  {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: 20,
  },
]);

const touchEnabled = isTouchDevice();

export const BwjSidePanel: React.FunctionComponent<IBwjSidePanelProps> = (props) => {

  const { footerButtons, onDismiss } = props;
  const usingFooterButtons = !!footerButtons && footerButtons.length > 0;

  const onRenderFooterContent = useCallback(() => (
    <>
      {usingFooterButtons && <div className={footerButtonTrayClass}>
        {footerButtons!.map((btnProps, index) => 
          <BwjButton key={index} {...btnProps} />
        )}
      </div>}
    </>
    ), [usingFooterButtons, footerButtons]);

  return (
    <Panel
      title={props.title}
      headerText={props.title}
      isOpen={props.showPanel}
      onDismiss={onDismiss}
      isLightDismiss={props.isLightDismiss}
      className={scrollablePanelClass}
      styles={panelStyles}
      type={props.panelType ?? PanelType.medium}
      closeButtonAriaLabel={props.closeButtonAriaLabel ?? 'Close'}
      onRenderFooterContent={onRenderFooterContent}
      isFooterAtBottom={usingFooterButtons}
      allowTouchBodyScroll={touchEnabled}
    >
      <BwjSemiFlexContainer
        pinHeight={true}
        styles={{ root: { flexGrow: 1, }}}
      >
        <BwjScrollContainer>
          {props.children}
          <div className={scrollButtonPaddingClass}></div>
        </BwjScrollContainer>
      </BwjSemiFlexContainer>
    </Panel>
  );
};
